module.exports = __webpack_public_path__ + "media/images/sb-loading-cc48da71.svg";